import { Capacitor, registerPlugin } from '@capacitor/core';

export interface IWebViewCachePlugin {
  clearCache(): Promise<void>;
}

/**
 * In-house replacement for the abandoned `capacitor-plugin-webview-cache`.
 * Native implementations live in the Android (`WebViewCachePlugin.java`) and
 * iOS (`WebViewCachePlugin.swift`) projects; on web it is a no-op.
 */
export const WebViewCache = registerPlugin<IWebViewCachePlugin>(
  'WebViewCache',
  {
    web: () => ({
      async clearCache() {
        // No-op on web: the browser manages its own cache.
      },
    }),
  }
);

/**
 * Best-effort cache clear that never throws: callers reload the page right
 * after, and a failed cache clear (e.g. a legacy shell whose old APK lacks
 * this plugin) must not block that reload.
 */
export async function clearWebViewCacheSafe(): Promise<void> {
  if (
    Capacitor.isNativePlatform() &&
    !Capacitor.isPluginAvailable('WebViewCache')
  ) {
    return;
  }
  try {
    await WebViewCache.clearCache();
  } catch (err) {
    console.error(err);
  }
}
